import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { Search, ChevronDown, ChevronUp, Plus } from 'react-feather';
import Input from '../ui/Input';
import Select from '../ui/Select';
import Table from '../ui/Table';
import colors from '../../theme/colors';
import presupuestosApiService from '../../services/http/presupuestosApiService';
import logger from '../../services/logger';

const CENTROS = [
  { value: 'CEDETECGROUP', label: 'Todos' },
  { value: 'CEDESCA', label: 'CEDESCA' },
  { value: 'CNTEC', label: 'CNTEC' },
];

const ESTADOS = [
  { value: '', label: 'Todos' },
  { value: '0', label: 'Gestionándose - Gestionándose' },
  { value: '1', label: 'Revisión Tit. - Gestionándose' },
  { value: '2', label: 'Pendiente Alum. - Interesado/informado' },
  { value: '3', label: 'Tramitación Secr. - Enviado a matricular' },
  { value: '4', label: 'Matriculado - Matriculado' },
  { value: '5', label: 'Rechazado - Desestimado' },
  { value: '6', label: 'Aceptado - Interesado/informado' },
];

const FormularioPresupuestos = () => {
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [filters, setFilters] = useState({
    headquarter: 'CEDETECGROUP',
    idPresupuesto: '',
    nombre: '',
    apellidos: '',
    dni: '',
    email: '',
    estado: '',
  });

  const handleChange = (e) => {
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = await presupuestosApiService.buscarPresupuestos(filters);
      setResults(Array.isArray(data) ? data : []);
    } catch (error) {
      logger.error('Error buscando presupuestos:', error);
      setResults([]);
    } finally {
      setIsLoading(false);
      setSearched(true);
    }
  };

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
          overflow: 'visible',
        }}
      >
        {/* Toolbar */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
          }}
        >
          <button
            type="button"
            onClick={() => setShowFilters(!showFilters)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.8rem',
              fontWeight: 600,
              color: '#374151',
              padding: '4px 8px',
              borderRadius: '6px',
            }}
          >
            <Search size={15} style={{ color: '#9ca3af' }} />
            Filtros
            {showFilters ? (
              <ChevronUp size={14} style={{ color: '#9ca3af' }} />
            ) : (
              <ChevronDown size={14} style={{ color: '#9ca3af' }} />
            )}
          </button>
          <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={() => navigate('/presupuestos/nuevo')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              padding: '6px 14px',
              fontSize: '0.75rem',
              fontWeight: 600,
              borderRadius: '6px',
              border: `1px solid ${colors.primary}`,
              backgroundColor: '#fff',
              color: colors.primary,
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
          >
            <Plus size={13} />
            Nuevo presupuesto
          </button>
          <button
            type="submit"
            disabled={isLoading}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              padding: '6px 14px',
              fontSize: '0.75rem',
              fontWeight: 600,
              borderRadius: '6px',
              border: 'none',
              backgroundColor: colors.primary,
              color: '#fff',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.5 : 1,
              transition: 'all 0.15s',
            }}
          >
            {isLoading ? (
              <Spinner style={{ height: '13px', width: '13px' }} />
            ) : (
              <Search size={13} />
            )}
            Buscar
          </button>
          </div>
        </div>

        {/* Filtros */}
        {showFilters && (
          <div
            style={{
              padding: '16px',
              opacity: isLoading ? 0.5 : 1,
              pointerEvents: isLoading ? 'none' : 'auto',
              transition: 'opacity 0.2s',
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '12px',
                marginBottom: '12px',
              }}
            >
              <Select
                label="Centro"
                name="headquarter"
                id="headquarterPresupuesto"
                value={filters.headquarter}
                onChange={handleChange}
                disabled={isLoading}
                options={CENTROS}
              />
              <Input
                label="ID Presupuesto"
                type="text"
                name="idPresupuesto"
                id="idPresupuesto"
                placeholder="ID"
                value={filters.idPresupuesto}
                onChange={handleChange}
                disabled={isLoading}
              />
              <Input
                label="Nombre"
                type="text"
                name="nombre"
                id="nombrePresupuesto"
                placeholder="Nombre alumno"
                value={filters.nombre}
                onChange={handleChange}
                disabled={isLoading}
              />
              <Input
                label="Apellidos"
                type="text"
                name="apellidos"
                id="apellidosPresupuesto"
                placeholder="Apellidos"
                value={filters.apellidos}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '12px',
              }}
            >
              <Input
                label="DNI"
                type="text"
                name="dni"
                id="dniPresupuesto"
                placeholder="DNI"
                value={filters.dni}
                onChange={handleChange}
                disabled={isLoading}
              />
              <Input
                label="Correo"
                type="email"
                name="email"
                id="emailPresupuesto"
                placeholder="Correo electrónico"
                value={filters.email}
                onChange={handleChange}
                disabled={isLoading}
              />
              <Select
                label="Estado"
                name="estado"
                id="estadoPresupuesto"
                value={filters.estado}
                onChange={handleChange}
                disabled={isLoading}
                options={ESTADOS}
              />
            </div>
          </div>
        )}
      </div>
    </form>
    {searched && (
      <div style={{ marginTop: '16px' }}>
        {results.length > 0 ? (
          <Table
            columns={[
              { Header: 'ID', accessor: 'Id' },
              { Header: 'Nombre', accessor: 'Nombre' },
              { Header: 'Apellidos', accessor: 'Apellidos' },
              { Header: 'DNI', accessor: 'DNI' },
              { Header: 'Correo', accessor: 'Correo' },
              { Header: 'Estado', accessor: 'Estado' },
              { Header: 'Sede', accessor: 'sede' },
            ]}
            data={results}
            defaultPageSize={10}
            showPaginationBottom
            className="-striped -highlight text-center"
            getTrProps={(_, rowInfo) => ({
              onDoubleClick: () => {
                const row = rowInfo.original;
                const hq = (row.sede || row.headquarter || 'cedesca').toLowerCase();
                navigate(`/presupuestos/${hq}/${row.Id}`);
              },
              style: { cursor: 'pointer' },
            })}
          />
        ) : (
          <p style={{ color: '#6b7280', fontSize: '0.85rem', textAlign: 'center', marginTop: '24px' }}>
            No se han encontrado presupuestos.
          </p>
        )}
      </div>
    )}
    </>
  );
};

export default FormularioPresupuestos;
